// src/components/projects/progressUi.tsx
// Shared, deterministic progress display helpers for projects/milestones.
// No AI language, no recommendations — pure data rendering.

import type { GoalTrackingStatus } from '../../types/api';

export const TRACKING_BADGE: Record<GoalTrackingStatus, { label: string; cls: string }> = {
  on_track: { label: 'On Track', cls: 'text-green-700 bg-green-100' },
  ahead: { label: 'Ahead', cls: 'text-blue-700 bg-blue-100' },
  behind: { label: 'Behind', cls: 'text-red-700 bg-red-100' },
  completed: { label: 'Done', cls: 'text-gray-700 bg-gray-100' },
  no_data: { label: 'No data', cls: 'text-gray-500 bg-gray-100' },
};

export function TrackingBadge({ status }: { status: GoalTrackingStatus }) {
  const { label, cls } = TRACKING_BADGE[status] ?? TRACKING_BADGE.no_data;
  return <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${cls}`}>{label}</span>;
}

const BAR_COLOR: Record<GoalTrackingStatus, string> = {
  on_track: 'bg-green-500',
  ahead: 'bg-blue-500',
  behind: 'bg-red-500',
  completed: 'bg-gray-400',
  no_data: 'bg-gray-300',
};

export function ProgressBar({
  percent,
  status,
}: {
  percent: number | null;
  status: GoalTrackingStatus;
}) {
  const pct = percent == null ? 0 : Math.max(0, Math.min(100, percent));
  return (
    <div className="w-full bg-gray-100 rounded-full h-2">
      <div
        className={`h-2 rounded-full transition-all ${BAR_COLOR[status] ?? 'bg-gray-300'}`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
